import { type IParticipant } from './event';

export interface IParticipantAvatar extends IParticipant {
  profileImageURL?: string;
}
